import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=0d50c205&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d50c205",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d50c205')) {
      api.createRecord('0d50c205', component.options)
    } else {
      api.reload('0d50c205', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=0d50c205&scoped=true&", function () {
      api.rerender('0d50c205', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QEot06hkMm3Y/JS/comp/SearchFilterTokens.vue"
export default component.exports